export enum NewsStatusesENUM {
  SAVED = 'SAVED',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED'
};



// WEBPACK FOOTER //
// ./src/app/common/enums/news-statuses.enum.ts